import { ActionsUnion } from "../../type/actionsUnion"
import createAction from "../../type/createAction"
import { IHealthStatusDto, IHealthStatusSection } from "../../type/healthStatus/IHealthStatusDto"
import { StoreState } from "../StoreState"

export type HealthStatusState = Readonly<{
    healthStatuses: { [webshopId: string]: IHealthStatusDto[] }
    // Currently the same is fetched for all webshops, but added like this, to in the future filter by enabled per webshop
    sections: { [webshopId: string]: IHealthStatusSection[] }
}>

const initialState: HealthStatusState = {
    healthStatuses: {},
    sections: {},
}

export const healthStatusReducerActions = {
    setHealthStatuses: (isGlobal: boolean, webshopId: string | undefined, healthStatuses: IHealthStatusDto[]) =>
        createAction("APP/SET_HEALTH_STATUSES", { isGlobal, webshopId, healthStatuses }),
    setSections: (isGlobal: boolean, webshopId: string | undefined, sections: IHealthStatusSection[]) =>
        createAction("APP/SET_HEALTH_STATUS_PAYMENT_TYPES", { isGlobal, webshopId, sections }),
}

function getHealthStatusKey(isGlobal: boolean, webshopId: string | undefined) {
    return isGlobal ? "global" : webshopId ?? ""
}

export type HealthStatusActions = ActionsUnion<typeof healthStatusReducerActions>

export const healthStatusReducer = (state: HealthStatusState = initialState, action: HealthStatusActions) => {
    switch (action.type) {
        case "APP/SET_HEALTH_STATUSES": {
            return {
                ...state,
                healthStatuses: {
                    ...state.healthStatuses,
                    [getHealthStatusKey(action.isGlobal, action.webshopId)]: action.healthStatuses,
                },
            }
        }
        case "APP/SET_HEALTH_STATUS_PAYMENT_TYPES": {
            return {
                ...state,
                sections: {
                    ...state.sections,
                    [getHealthStatusKey(action.isGlobal, action.webshopId)]: action.sections,
                },
            }
        }
        default: {
            return state
        }
    }
    return state
}

export const healthStatusSelectors = {
    healthStatuses: (state: StoreState, isGlobal: boolean, webshopId: string | undefined) =>
        state.healthStatus.healthStatuses[getHealthStatusKey(isGlobal, webshopId)],
    sections: (state: StoreState, isGlobal: boolean, webshopId: string | undefined) =>
        state.healthStatus.sections[getHealthStatusKey(isGlobal, webshopId)],
}
